<template>
    <div class="overflow-x-auto mt-sm">
        <table class="table condensed striped">
            <tbody>
                <tr>
                    <td class="w-2/5">Switchport</td>
                    <td
                        v-if="address.switch_port_information"
                    >
                        <a
                            :href="route('admin.operations.switchPort', { name: address.switch_port_information })"
                            class="notranslate"
                        >
                            {{ address.switch_port_information }}
                        </a>
                    </td>
                    <td
                        v-else
                    >
                        -
                    </td>
                    <td
                        v-if="canEdit"
                        class="flex justify-end"
                    >
                        <button
                            class="btn-icon"
                            @click="$modal.show('edit-switch-port')"
                        >
                            <font-awesome-icon icon="pencil" size="sm" />
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <adaptive-form-modal
            v-if="canEdit"
            :name="`edit-switch-port`"
            :title="`Redigera Switchport`"
            method="patch"
            :action="route('api.delivery-projects.addresses.switch-port.update', address.id)"
            :redirect-to="redirectTo"
        >
            <div class="grid">
                <div class="column w-1/2">
                    <div class="form-group">
                        <switch-port-search
                            :address="address"
                            :default-query="getSwitchPortParts(address.switch_port_information).nodeAndSwitch || 'AUTO'"
                            :type="'switch'"
                        />
                    </div>
                </div>
                <div class="column w-1/6">
                    <div class="form-group">
                        <div style="line-height: 56px; text-align: center;">
                            &nbsp;-&nbsp;
                        </div>
                    </div>
                </div>
                <div class="column w-1/3">
                    <div class="form-group">
                        <input
                            type="text"
                            name="port"
                            class="bg-white text-neutral-darker form-input"
                            :placeholder="portPlaceholder"
                            autocomplete="off"
                            :value="getSwitchPortParts(address.switch_port_information).port"
                            list="port-list"
                        >
                        <datalist
                            id="port-list"
                        >
                            <option
                                v-for="(option) in portOptions"
                                :value="option"
                            />
                        </datalist>
                    </div>
                </div>
                <div v-if="! getSwitchPortParts(address.switch_port_information).port" class="column w-full">
                    <div class="flex">
                        <div class="pr-sm">
                            <p>
                                <font-awesome-icon icon="info-circle" class="text-xs" />
                            </p>
                        </div>
                        <div>
                            <p>
                                FQPN will be determined automatically
                                if &ldquo;AUTO&rdquo; is entered as switch name above,
                                when the address becomes ready for commissioning.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            address: {
                type: Object,
                required: true,
            },
            canEdit: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
            };
        },
        computed: {
            redirectTo() {
                return window.location.href;
            },
            portPlaceholder() {
                return this.address.country_code === 'us' ? '1/1/_/_' : '0/0/_';
            },
            portOptions() {
                var a;
                var b;
                var i = 0;
                var option;
                var options = {};
                var prefixes = ['', 'x'];
                var prefixIndex;
                var prefixPosition;

                if (this.address.country_code === 'us') {
                    for (prefixIndex = 0; prefixIndex < prefixes.length; prefixIndex++) {
                        for (prefixPosition = 0; prefixPosition < 3; prefixPosition++) {
                            if (prefixPosition > 0 && ! prefixes[prefixIndex]) continue;

                            for (a = 1; a <= 8; a++) {
                                for (b = 1; b <= 36; b++) {
                                    option = [1, 1, a, b];

                                    option[prefixPosition] = prefixes[prefixIndex] + option[prefixPosition];

                                    options[i++] = option.join('/');
                                }
                            }
                        }
                    }
                } else {
                    for (prefixIndex = 0; prefixIndex < prefixes.length; prefixIndex++) {
                        for (prefixPosition = 0; prefixPosition < 2; prefixPosition++) {
                            if (prefixPosition > 0 && ! prefixes[prefixIndex]) continue;

                            for (a = 1; a <= 48; a++) {
                                  option = [0, 0, a];

                                  option[prefixPosition] = prefixes[prefixIndex] + option[prefixPosition];

                                  options[i++] = option.join('/');
                              }
                        }
                    }
                }

                return options;
            },
        },
        methods: {
            getSwitchPortParts(switchPort) {
                switchPort = switchPort || String();

                var defaultString = '';
                var specialMatch = switchPort.match(/(^([A-Za-z\d\-\\/]+\.)*as\d+\.sto\d+(\.[A-Za-z\d]+)*\.se(-[A-Za-z\d\-\\/]+)*$)|(^AUTO$)/);

                if (specialMatch) {
                    return {
                        node: defaultString,
                        nodeAndSwitch: specialMatch[0],
                        port: defaultString,
                        switch: defaultString,
                    };
                }

                var nodeAndSwitchMatch = switchPort.match(/^([A-Za-z\d]+){1}(-[A-Za-z\d]+)+-/);
                var nodeMatch = switchPort.match(/^[A-Za-z\d]+/);
                var portMatch = switchPort.match(/-([Xx]?\d+\/)*\d+$/);
                var switchMatch = switchPort.match(/(-[A-Za-z\d]+)+-/);

                return {
                    node: ! nodeMatch ? defaultString : nodeMatch[0],
                    nodeAndSwitch: ! nodeAndSwitchMatch ? defaultString : nodeAndSwitchMatch[0].substr(0, nodeAndSwitchMatch[0].length - 1),
                    port: ! portMatch ? defaultString : portMatch[0].substr(1),
                    switch: ! switchMatch ? defaultString : switchMatch[0].substr(1, switchMatch[0].length - 2),
                };
            },
            updatePortSuggestions(event) {
                if (! event) return;
                if (! event.target) return;

                var isEnabled = false;
                var options = document.querySelectorAll('#port-list option');

                options.forEach(function (option) {
                    isEnabled = option.value.indexOf(event.target.value) > -1;

                    option.disabled = isEnabled ? null : 'disabled';
                });
            },
        },
    };
</script>
